import clsx from "clsx";
import { memo } from "react";

import { Typography } from "../typography";

import type { IContentDivider } from "./types";
import classes from "./styles.module.scss";

export const ContentDivider = memo(function ContentDivider(
  props: IContentDivider,
) {
  const { variant = "line", className, text } = props;

  switch (variant) {
    case "line":
      return <div className={clsx([className, classes.line])} />;
    case "lineSpacing":
      return (
        <div className={clsx([className, classes.lineSpacing])}>
          <div className={clsx([classes.line])} />
        </div>
      );
    case "text":
      return (
        <div className={clsx([className, classes.text])}>
          <Typography
            fontType={"subheading-x-small"}
            themeColor={"text-soft-400"}
          >
            {text}
          </Typography>
        </div>
      );
    case "solidText":
      return (
        <div className={clsx([className, classes.solidText])}>
          <Typography
            fontType={"subheading-x-small"}
            themeColor={"text-soft-400"}
          >
            {text}
          </Typography>
        </div>
      );
  }
});
